import { useLayout } from "@/lib/preFetch/preFetchLayout"
import { CategoryNavDocument } from "@/lib/prismicio/types.generated"
import { SidebarGroupItem, SidebarGroupList, SidebarGroupTitle } from "@jog/react-components"
import { type CSSProperties, PropsWithChildren, memo } from "react"

export const Sidebar = memo(function Sidebar({ nav }: PropsWithChildren<{ nav: CategoryNavDocument["data"] }>) {
    const { layout } = useLayout()
    return (
        <div className="space-y-10 text-black" style={{ "--tag-size": "10px" } as CSSProperties}>
            {[...nav.body].map((slice, index) => (
                <div key={index}>
                    <SidebarGroupTitle className="my-1.75 text-xs" titleField={slice.primary.sub_category} />
                    <SidebarGroupList className="space-y-2 py-1 text-13">
                        {slice.items.map((item, index) => (
                            <SidebarGroupItem
                                item={item}
                                hoverUnderline={layout.categoryNavHover.underline}
                                key={index}
                            />
                        ))}
                    </SidebarGroupList>
                </div>
            ))}
        </div>
    )
})
